import Vue from 'vue'
import Component from 'vue-class-component'
import moduleStore from '../../store/videoEditor'
import PageState from '../../store/state';
import { toast } from '@/utils/util';

@Component({
  components: {
  }
})
@moduleStore.initVuex({
	mutationNames: moduleStore.mutationNames,
	actionNames: moduleStore.actionNames
})
export default class BrainPowerTitle extends Vue {
  state = new PageState();
  // 选中图片
  checkImg = 'https://tc-nj-backend-ms-pub-cdn.mobvoi.com/rd2-cdn/yuanchuangdao/ycdbrain/check.png'
  // 未选中图片
  unCheckedImg = 'https://tc-nj-backend-ms-pub-cdn.mobvoi.com/rd2-cdn/yuanchuangdao/ycdbrain/unchecked.png'
  // 智能标题列表
  brainTitleList = []
  // 选中的智能标题对像
  selectInfo:any = {}
  queryTitleTimer = null
  // 生成状态 0 默认 1 生成中
  generateStatus = 0
  created(moduleData: IinjectDatas) {
    this.state = <PageState>moduleData.state;
  }
  get contentHeight() {
    return this.state.styleContentHeight || '426px'
  }
  mounted() {
    this.getBrainList()
  }
  /**
   * 获取生成记录
   */
  getBrainList() {
    const params = {
      page: 1,
      size: 10000,
      type: 'TITLE',
      uniqueId: this.state.articleInfo.uniqueId
    }
    this.$http('getBrainRecordList', params).then((res) => {
      if (res.code === 200) {
        const { results } = res.data
        if (results && results.length) {
          this.brainTitleList = results
        }
      }
    })
  }
  /**
   * 生成智能标题
   */
  generateTitle() {
    const articleInfo = this.state.articleInfo
    const extendVO:any = articleInfo.extendVO
    const params  ={
      articleId: articleInfo.articleId,
      uniqueId: articleInfo.uniqueId,
      titleVO: {
        content: extendVO.articleTransform ? articleInfo.transformContent : extendVO.originContent
      }
    }
    if (this.generateStatus === 1) return
    this.generateStatus = 1
    this.$http('generateTitleApi', params).then(res => {
      if (res.code === 200 && res.data.id) {
        this.queryGenerateResult(res.data.id)
      } else {
        toast('生成智能标题失败')
        this.generateStatus = 0
      }
    }).catch(() => {
      this.generateStatus = 0
    })
  }
  /**
   * 查询生成结果
   * @param id
   */
  queryGenerateResult(id) {
    this.$http('queryRecordStatus', {recordIds: [id]}).then(res => {
      if (res.code === 200) {
        const status = res.data[0].status
        if (status === 1) {
          this.queryTitleTimer = setTimeout(() => {
            this.clearQueryTiltTimer()
            this.queryGenerateResult(id)
          }, 3000)
        } else if(status === 2) {
          this.clearQueryTiltTimer()
          this.getBrainList()
          this.generateStatus = 0
        } else {
          toast('生成智能标题失败')
          this.clearQueryTiltTimer()
          this.generateStatus = 0
        }
      } else {
        toast('生成智能标题失败')
        this.clearQueryTiltTimer()
        this.generateStatus = 0
      }
    }).catch(() => {
      this.generateStatus = 0
    })
  }
  clearQueryTiltTimer() {
    this.queryTitleTimer && clearTimeout(this.queryTitleTimer)
    this.queryTitleTimer = null
  }
  /**
   * 选择智能标题
   * @param info 
   * @returns 
   */
  selectBrainTitle(info) {
    // if (this.selectInfo.id === info.id) {
    //   this.selectInfo = {}
    //   return
    // }
    // this.selectInfo = info
    this.$bus.$emit(this.$EventBusKey.ADD_COVER_TEXT, info.output.content)

  }
}